<template>
  <div class="footer">
    <Container class="container-spacing-md container-none">
      <div class="footer-content">
        <div>
          <div class="footer-wrapper">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.569 19.9953L19.2698 20.3526C18.5293 21.3253 17.3832 21.928 16.141 21.9979C14.2139
                22.0508 12.5588 21.1157 11.0171 20.1012C9.43464 19.0712 7.96262 17.889 6.62332 16.5725C5.81366
                15.7835 5.0564 14.9452 4.35612 14.0627C3.24973 12.6512 2.20682 11.1295 2.01637 9.3166C1.89275
                7.9619 2.475 6.63704 3.56713 5.78791L3.92082 5.48797C4.7179 4.80473 5.92407 4.84339 6.6732
                5.57619L8.76809 7.61401C9.1314 7.96364 9.33584 8.44013 9.33584 8.93727C9.33584 9.43441 9.1314
                9.91089 8.76809 10.2605C8.47936 10.5342 8.31595 10.9094 8.31465 11.3015C8.31465 12.2631 9.15805
                13.1585 9.83821 13.7804C10.5344 14.4811 11.3191 15.0932 12.1734 15.6021C12.9352 15.9991 13.8194
                16.1887 14.4769 15.5006C14.8209 15.1313 15.3033 14.9124 15.8153 14.8933C16.3272 14.8742 16.8255
                15.0566 17.1975 15.3992L19.3695 17.3576C20.1264 18.0548 20.2129 19.1979 19.569 19.9953Z"
                fill="white"
              />
              <path
                d="M19.9304 10C20.2222 8.08726 19.5865 6.14978 18.2184 4.78162C16.8502 3.41346 14.9127 2.77783 13 3.06964"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9606 10C17.1265 8.90708 16.763 7.80037 15.9813 7.0187C15.1996 6.23703 14.0929 5.87351 13 6.03944"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p>
              Customer Centre
            </p>
          </div>
          <ul class="footer-list">
            <li class="footer-list-item">
              Mon-Fri 7:30 – 18:00
            </li>
            <li class="footer-list-item">
              0850 003 333 (Slovakia)
            </li>
            <li class="footer-list-item">
              +421 2 2081 1811 (Third Country)
            </li>
            <li class="footer-list-item">
              <a href="mailto:union@union.sk">union@union.sk</a>
            </li>
          </ul>
        </div>

        <div>
          <div class="footer-wrapper">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 1.80005C6.33858 1.80005 1.80005 6.38537 1.80005 12C1.80005 14.3863 2.59546 16.5386 3.95234
                18.2698C3.34409 19.2991 2.64225 20.656 2.64225 20.656L5.87069 20.1413C7.60188 21.4514 9.70739
                22.2 12 22.2C17.6615 22.2 22.2 17.6147 22.2 12C22.2 6.38537 17.6615 1.80005 12 1.80005Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15 17.9006V18.4575C15 18.8752 14.6719 19.2 14.25 19.2H11.25C10.8281 19.2 10.5 18.8752 10.5
                18.4575V17.1117V13.5846C10.5 13.1669 10.1719 12.842 9.75 12.842C9.32812 12.842 9 12.5172 9
                12.0995V11.5426C9 11.1249 9.32812 10.8 9.75 10.8H12.75C13.1719 10.8 13.5 11.1249 13.5
                11.5426V16.3691C13.5 16.7868 13.8281 17.1117 14.25 17.1117C14.6719 17.1581 15 17.4829 15 17.9006Z"
                fill="white"
              />
              <ellipse
                cx="12"
                cy="7.20002"
                rx="1.8"
                ry="1.8"
                fill="white"
              />
            </svg>
            <p>
              Useful Links
            </p>
          </div>
          <ul class="footer-list">
            <li class="footer-list-item">
              <a target="_blank" href="https://www.union.sk/vyuzivanie-cookies/">
                Cookies Settings
              </a>
            </li>
            <li class="footer-list-item">
              <a target="_blank" href="https://www.union.sk/ochrana-osobnych-udajov/">
                Personal Data Protection
              </a>
            </li>
            <li class="footer-list-item">
              <a target="_blank" href="https://www.union.sk/union-o-poistovni/">
                About Us
              </a>
            </li>
          </ul>
        </div>
      </div>
      <p class="footer-copyright">
        © 2019 - 2023 | Union poisťovňa, a. s.
      </p>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container/Container.vue';

export default {
  name: 'Footer',
  components: {
    Container,
  },
};
</script>
